import { AxiosError } from 'axios';
import { Buffer } from 'buffer';
import React, { FormEvent, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setItem } from 'src/helpers/common/localStorage';
import validators from 'src/helpers/validators';
import { useDialog } from 'src/hooks/useDialog';
import useForm from 'src/hooks/useForm';
import { Auth } from 'src/model/Auth';
import { api } from 'src/services/api';
import { REACT_APP_AUTH, REACT_APP_USER } from 'src/utils/config';
import { setLoading, useLoading } from '../../../../redux/loading/loadingSlice';

import {
  FormInputChangePassoword,
  FormInputChangePassowordEmail,
  FormInputNameLogin,
} from '../../types';
import { LoginUI } from './ui';
// import { websocketService } from 'src/services/websocket';

export const LoginScreen: React.FC = (): JSX.Element => {
  const [shouldShowPasswordToText, setShouldShowPasswordToText] =
    useState(false);
  const { loading } = useSelector(useLoading);
  const dispatch = useDispatch();
  const { onToggle } = useDialog();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoCode, setIsInfoCode] = useState(false);

  const history = useHistory();

  const handleOnGoTo = (href: string): void => {
    history.replace(href);
  };

  const {
    formData: formDataLogin,
    formErrors: formErrorsLogin,
    setErrors: setErrorsLogin,
    onChangeFormInput: onChangeFormInputLogin,
    isFormValid: isFormValidLogin,
    resetForm: resetFormLogin,
  } = useForm({
    initialData: {
      email: '',
      password: '',
    },
    validators: {
      email: [validators.required],
      password: [
        validators.required,
        /*
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
        */
      ],
    },
  });

  const {
    formData: formDataRecoverPassword,
    formErrors: formErrorsRecoverPassword,
    setErrors: setErrorsRecoverPassword,
    onChangeFormInput: onChangeFormInputRecoverPassword,
    isFormValid: isFormValidRecoverPassword,
    resetForm: resetFormRecoverPassword,
  } = useForm({
    initialData: {
      email: '',
    },
    validators: {
      email: [validators.required],
    },
  });

  const {
    formData: formDataInfoCodePassword,
    formErrors: formErrorsInfoCodePassword,
    setErrors: setErrorsInfoCodePassword,
    onChangeFormInput: onChangeFormInputInfoCodePassword,
    isFormValid: isFormValidInfoCodePassword,
    resetForm: resetFormInfoCodePassword,
  } = useForm({
    initialData: {
      code: '',
      newPassword: '',
      confirmPassword: '',
    },
    validators: {
      code: [validators.required],
      newPassword: [
        validators.required,
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
      ],
      confirmPassword: [
        validators.required,
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
      ],
    },
  });

  const handleOnSubmit = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();

      if (isFormValidLogin()) {
        dispatch(setLoading(true));
        await login(
          formDataLogin[FormInputNameLogin.email],
          formDataLogin[FormInputNameLogin.password]
        );
        resetFormLogin();
        handleOnGoTo('/');
        onToggle();
      }
    } catch (error) {
      const err = error as AxiosError;
      if (err.code && err.code === 'ERR_BAD_REQUEST') {
        setErrorsLogin({
          email: ['E-mail ou Senha inválida'],
          password: ['E-mail ou Senha inválida'],
        });
      } else {
        toast.warn('Falha ao realizar login, tentar novamente mais tarde');
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const login = async (email: string, password: string): Promise<void> => {
    const payload = Buffer.from(`${email}:${password}`, 'utf8').toString(
      'base64'
    );
    const { data } = await api.post<Auth>(
      '/auth',
      {
        grant_type: 'client_credentials',
      },
      {
        headers: {
          Authorization: `Basic ${payload}`,
        },
      }
    );
    setItem(String(REACT_APP_AUTH), data.token);
    setItem(String(REACT_APP_USER), data.user);
  };

  const handleOnTogglePasswordToText = (): void =>
    setShouldShowPasswordToText(!shouldShowPasswordToText);

  //   const handleOnTogglePasswordToText2 = (): void =>
  //     setShouldShowPasswordToText2(!shouldShowPasswordToText2);

  //   const showModal = ({ value, title }: ShouldShowModalProps): void => {
  //     setShouldShowModal(value);
  //     onChangeTitle(title);
  //     onSetVisible(true);
  //   };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModalResetPassword = () => {
    setIsModalOpen(true);
  };
  const emailRef = useRef<string>('');

  const handleResetPassword = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidRecoverPassword()) {
        dispatch(setLoading(true));
        const email =
          formDataRecoverPassword[FormInputChangePassowordEmail.email];
        emailRef.current = email;
        const payload = {
          email,
        };
        await api.post('/user/recover-password', payload);
        toast.success('Código enviado com sucesso');
        resetFormRecoverPassword();
        setIsInfoCode(true);
      }
    } catch (error) {
      const err = error as AxiosError;
      if (err.code && err.code === 'ERR_BAD_REQUEST') {
        setErrorsRecoverPassword({
          email: ['E-mail inválido'],
        });
      } else {
        toast.warn('Falha ao enviar código, tentar novamente mais tarde');
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleOnSubmitInfoCodePassoword = async (
    e: FormEvent
  ): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidInfoCodePassword()) {
        const newPassword =
          formDataInfoCodePassword[FormInputChangePassoword.newPassword];
        const confirmPassword =
          formDataInfoCodePassword[FormInputChangePassoword.confirmPassword];
        if (newPassword !== confirmPassword) {
          setErrorsInfoCodePassword({
            newPassword: ['As senhas não coincidem'],
            confirmPassword: ['As senhas não coincidem'],
          });
          return;
        }
        dispatch(setLoading(true));

        const payload = {
          code: formDataInfoCodePassword[FormInputChangePassoword.code],
          password: newPassword,
          confirmPassword: confirmPassword,
          email: emailRef.current,
        };
        await api.post('/user/change-password', payload);
        toast.success('Senha alterada com sucesso');
        resetFormInfoCodePassword();
        setIsInfoCode(false);
        handleCloseModal();
      }
    } catch (error) {
      const err = error as AxiosError;
      if (err.code && err.code === 'ERR_BAD_REQUEST') {
        setErrorsInfoCodePassword({
          email: ['E-mail inválido'],
        });
      } else {
        toast.warn('Falha ao enviar código, tentar novamente mais tarde');
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <LoginUI
      state={loading}
      shouldShowPasswordToText={shouldShowPasswordToText}
      formData={formDataLogin}
      formErrors={formErrorsLogin}
      onChangeFormInput={onChangeFormInputLogin}
      // enableLoginPassword={enableLoginPassword}
      // onCheckCPF={onCheckCPF}
      onSubmit={handleOnSubmit}
      onTogglePasswordToText={handleOnTogglePasswordToText}
      openModalResetPassword={handleOpenModalResetPassword}
      formDataRecoverPassword={formDataRecoverPassword}
      formErrorsRecoverPassoword={formErrorsRecoverPassword}
      onChangeFormInputRecoverPassoword={onChangeFormInputRecoverPassword}
      onSubmitRecoverPassoword={handleResetPassword}
      isModalOpen={isModalOpen}
      handleCloseModal={handleCloseModal}
      isInfoCode={isInfoCode}
      onSubmitInfoCodePassoword={handleOnSubmitInfoCodePassoword}
      formDataInfoCodePassword={formDataInfoCodePassword}
      formErrorsInfoCodePassoword={formErrorsInfoCodePassword}
      onChangeFormInputInfoCodePassoword={onChangeFormInputInfoCodePassword}
    />
  );
};
